import * as yup from 'yup';
import { FormValidationUtil, FileUtil } from '../../../utils';

export const initialValues = {
  category: '',
  hrResponsible: '',
  subject: '',
  message: '',
  files: [],
};

export const validationSchema = yup.object().shape({
  category: yup.string().required('Category is required'),
  hrResponsible: yup
    .object()
    .typeError('HR Responsible is required')
    .required('HR Responsible is required'),
  subject: yup.string().required('Subject is required'),
  message: yup.string().required('Message is required'),
  files: yup
    .array()
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
});

export const TICKET_CATEGORY = [
  { value: 'Travel', label: 'Travel' },
  { value: 'Bonus', label: 'Bonus' },
  { value: 'Performance', label: 'Performance' },
  { value: 'Leave', label: 'Leave' },
  { value: 'Work From Home', label: 'Work From Home' },
  { value: 'Expense', label: 'Expense' },
  { value: 'Over Time', label: 'Over Time' },
  { value: 'Loan', label: 'Loan' },
];
